export default __webpack_public_path__ + "static/linkedin-58ad5692be7941ed06b7fb65dee0504a.svg";